module.exports = __webpack_public_path__ + "static/img/wdsj1-4.689d3f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsj1-4.png
// module id = 879
// module chunks = 0